import { PureComponent } from 'react'
import styled from 'glamorous'
import { $ } from 'utils'
import { Button } from 'components'


const FileContainer = styled.label({
  position: 'relative',
  display: 'flex',
  alignItems: 'stretch',
})

const FileInput = styled.input({
  position: 'absolute',
  width: 0.01,
  height: 0.01,
  top: 0,
  left: 0,
  opacity: 0,
})


class FileButton extends PureComponent {
  state = {
    isLoading: false
  }

  reset = () => {
    this.setState({ isLoading: false })
  }

  handleChange = (e) => {
    if (typeof this.props.onChange === 'function') {
      this.setState({ isLoading: true })

      const promise = this.props.onChange()
      if (promise && promise.then !== undefined) {
        promise
          .then(() => this.reset())
          .catch(() => this.reset())
      } else {
        this.reset()
      }
    }
  }

  render() {
    const { fileRef, disabled, onChange, buttonProps: { text, ...buttonProps }, ...props } = this.props
    const { isLoading } = this.state
    return (
      $(FileContainer,
        $(FileInput, {
          type: 'file',
          accept: 'image/*',
          innerRef: fileRef,
          onChange: e => this.handleChange(e),
          disabled: disabled || isLoading,
          ...props
        }),
        $(Button, {
          tag: 'span',
          isDisabled: disabled,
          isLoading,
          ...buttonProps
        }, text)
      )
    )
  }
}

export default FileButton



// WEBPACK FOOTER //
// ./src/components/FileButton.js